import React from 'react'
import PropTypes from 'prop-types'
import { simpleStrDate, currencyFormat } from 'utils/format'
import { Visibility } from '@material-ui/icons'
import { DescList } from 'ui-components/DescList'
import { Button } from 'ui-components/Button'
import { DescItemList } from 'ui-components/DescItemList'
import { ContainerName, ContainerPrice } from './styles'

export default function Order({ order, onClick }) {
  const handleClick = () => {
    onClick(order.id)
  }

  const getStatus = () => (
    order.attributes.was_paid ? 'Pago' : order.attributes.status
  )

  return (
    <DescList>
      <ContainerName>
        <DescItemList label="Número">
          { order.attributes.code }
        </DescItemList>
        <DescItemList label="Cliente">
          { order.attributes.customer_info.name }
        </DescItemList>
        <Button buttonType="icon" onClick={handleClick}>
          <Visibility />
        </Button>
      </ContainerName>

      <ContainerPrice>
        <DescItemList label="Data">
          { simpleStrDate(order.attributes.date) }
        </DescItemList>
        <DescItemList label="Canal">
          { order.attributes.channel }
        </DescItemList>
        <DescItemList label="Status">
          { getStatus() }
        </DescItemList>
        <DescItemList label="Valor R$">
          { currencyFormat(order.attributes.net_value) }
        </DescItemList>
      </ContainerPrice>
    </DescList>
  )
}

Order.propTypes = {
  order: PropTypes.objectOf(PropTypes.any),
  onClick: PropTypes.func.isRequired,
}

Order.defaultProps = {
  order: {},
}
